<template>
  <div class="pre-old-stu">
    <color-list
      :title="$t('app.roomType')"
      :color-list="colorList"
    ></color-list>
    <color-list
      :title="$t('app.roomStatus')"
      :color-list="colorListSecond"
    ></color-list>
    <color-list
      :title="$t('app.studentType')"
      :color-list="colorListThird"
    ></color-list>
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-select
      size="small"
      v-model="search.isKeep"
      :placeholder="$t('app.applyOldView.isKeep')"
      style="width: 200px; margin-right: 10px"
    >
      <el-option :label="'是'" :value="'1'"> </el-option>
      <el-option :label="'否'" :value="'0'"> </el-option>
    </el-select>
    <el-button type="primary" size="small" @click="reset">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      icon="el-icon-search"
      size="small"
      @click="getList"
      >{{ $t("app.search") }}</el-button
    >
    <download-excel
      type="button"
      class="el-button el-button--success el-button--small"
      :data="tableData"
      :fields="exportColumns"
      header="舊生住宿申請表"
      name="舊生住宿申請表.xls"
      :footer="this.generateExportCondition()"
      >導出</download-excel
    >
    <br />
    <el-button
      type="primary"
      size="small"
      style="margin-top: 10px"
      @click="batchConfirmation"
      v-show="multipleSelection.length > 0"
      >{{ $t("app.batchConfirmation") }}</el-button
    >
    <el-button
      type="warning"
      size="small"
      style="margin-top: 10px"
      @click="batchDebit"
      v-show="showBatchDebit()"
      >{{ $t("app.batchDebit") }}</el-button
    >
    <div class="table-container">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        :data="tableData"
        :cell-style="cellStyle"
        style="width: 100%; color: black"
        height="550"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          align="left"
          width="360px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.haveFee"
              size="small"
              type="primary"
              @click="confirmItem(scope.row)"
              >{{ $t("app.confirmS") }}</el-button
            >
            <el-button size="small" type="danger" @click="refuse(scope.row)">{{
              $t("app.refuse")
            }}</el-button>
            <el-button size="small" type="primary" @click="adjust(scope.row)">{{
              $t("app.adjustment")
            }}</el-button>
            <el-button
              size="small"
              type="success"
              @click="adjustApplication(scope.row)"
              >{{ $t("app.viewDetails") }}</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="debit(scope.row)"
              :disabled="isDebit(scope.row)"
              >{{ $t("app.debit") }}</el-button
            >
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            v-if="col.model === 'studentNumber' || col.model === 'isKeep'"
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            width="120px"
          >
            <template slot-scope="scope">
              <template
                v-if="col.model === 'nameEnglish' || col.model === 'status'"
              >
                <div style="word-break: normal">
                  {{ scope.row[col.model] }}
                </div>
              </template>
              <template v-else>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <adjust-modal
      ref="adjustModal"
      @adjustSuccess="adjustSuccess"
    ></adjust-modal>
    <details-modal ref="detailsModal"></details-modal>
    <debit-modal ref="debitModal" @debitSuccess="getList"></debit-modal>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import AdjustModal from "./modules/NewStuAdjustModal";
import DetailsModal from "./modules/DetailsModal";
import ColorList from "@/components/tools/ColorList";
import DebitModal from "./modules/DebitConfirmModal";
import {
  getList,
  confirm,
  batchConfirm,
  refuse,
} from "@/api/dormitoryManagement/preAllocOldStu";
import {
  getRoomColor,
  getBedColor,
  getPersonColor,
} from "@/api/dormitoryManagement/list";
export default {
  components: {
    AdjustModal,
    DetailsModal,
    ColorList,
    DebitModal,
    DownloadExcel: JsonExcel,
  },
  data() {
    return {
      searchInput: [
        { model: "roomCode", label: this.$t("app.roomCode") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "contact", label: this.$t("app.contactInformation") },
      ],
      multipleSelection: [],
      column: [
        { model: "room", label: this.$t("app.room") },
        { model: "bed", label: this.$t("app.bed") },
        // { model: "otherName", label: this.$t("app.otherName") },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "gender", label: this.$t("app.gender") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "localOrNot",
          label: this.$t("app.localOrNot"),
        },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        { model: "status", label: this.$t("app.status") },
        { model: "isKeep", label: this.$t("app.applyOldView.isKeep") },
        {
          model: "specialTypeDetail",
          label: this.$t("app.applyOldView.specialTypeDetail"),
        },
      ],
      colorList: [],
      colorListSecond: [],
      colorListThird: [],
      search: {
        roomCode: "",
        studentNumber: "",
        applyCode: "",
        name: "",
        contact: "",
        orderKey: "",
        orderType: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      exportColumns: {
        中文名: "nameChina",
        英文名: "nameEnglish",
        學生編號: "studentNumber",
        "本地/非本地": "localOrNot",
        現有房號: "room",
        是否續住: "isContinueLodgeText",
        退宿日期: "checkOutDate",
        是否轉房: "isChange",
        轉房選擇: "changeType",
        "房型選擇（本學期不住宿舍的同學）": "selectedRoomTypeText",
        其他要求: "requirement"
      }
    };
  },
  created() {
    this.getColor();
    this.getList();
  },
  computed: {
    selectList() {
      return this.multipleSelection.map((_) => _.studentNumber);
    },
  },
  methods: {
    getColor() {
      getRoomColor().then((res) => {
        if (res.data === null || res.data === undefined) {
          return;
        }
        this.colorList = res.data.map((item) => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color,
          };
        });
      });
      getBedColor().then((res) => {
        if (res.data === null || res.data === undefined) {
          return;
        }
        this.colorListSecond = res.data.map((item) => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color,
          };
        });
      });
      getPersonColor().then((res) => {
        this.colorListThird = res.data.map((item) => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color,
          };
        });
      });
    },
    getList() {
      getList({
        ContactMobile: this.search.contact,
        RoomIndex: this.search.roomCode,
        Name: this.search.name,
        StudentCode: this.search.studentNumber,
        ApplicationCode: this.search.applyCode,
        IsContinueSameRoom: this.search.isKeep,
        PageIndex: this.currentPage,
        PageSize: this.size,
        OrderKey: this.search.orderKey,
        OrderType: this.search.orderType,
      }).then((res) => {
        if (res.data.Items === null || res.data.Items === undefined) {
          this.tableData = [];
          this.total = 0;
          return;
        }
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            applicationNumber: item.ApplicationCode,
            bed: item.Bed,
            bedState: item.BedState,
            bedColor: item.BedStateColor,
            bedStateText: this.returnBedStateText(item.BedState),
            checkOutDate: item.CheckOutDate,
            nameChina: item.ChineseName,
            contactInformation: item.ContactMobile,
            currentRoom: item.CurrentRoom,
            status: item.DebitState,
            nameEnglish: item.FullName,
            gender: item.Gender,
            isContinueLodge: item.IsContinueLodge,
            isContinueLodgeText: this.returnIsContinueLodge(
              item.IsContinueLodge
            ),
            isContinueSameRoom: item.IsContinueSameRoom,
            isKeep: item.IsKeepRoom,
            isChange: this.returnIsChange(item.IsKeepRoom),
            requirement: item.OtherRequirement,
            changeType: item.RoomChangeType,
            room: item.RoomIndex,
            roomState: item.RoomState,
            roomType: item.RoomType,
            roomTypeText: this.returnRoomTypeText(item.RoomType),
            roomColor: item.RoomTypeColor,
            studentNumber: item.StudentCode,
            specialType: item.StudentSpecialType,
            studentTypeText: this.returnStudentTypeText(
              item.StudentSpecialType
            ),
            personColor: item.SpecialTypeColor,
            debitNo: item.DebitNo,
            otherName: item.OtherName,
            specialTypeDetail: item.SpecialTypeDetail,
            haveFee: item.HaveFee,
            selectedRoomType: item.SelectedRoomType,
            selectedRoomTypeText: this.returnRoomTypeText(
              item.SelectedRoomType
            ),
            localOrNot: item.LocalOrNot,
          };
        });
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    reset() {
      this.search.roomCode = "";
      this.search.studentNumber = "";
      this.search.applyCode = "";
      this.search.name = "";
      this.search.contact = "";
    },
    adjust(row) {
      this.$refs.adjustModal.edit(row, "old");
    },
    adjustSuccess() {
      this.getList();
    },
    adjustApplication(row) {
      this.$refs.detailsModal.edit(row);
    },
    batchConfirmation() {
      batchConfirm({ StudentCodeGroup: this.selectList }).then(() => {
        this.success();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirmItem(row) {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        confirm({
          StudentCode: row.studentNumber,
        }).then(() => {
          this.success();
        });
      });
    },
    refuse(row) {
      this.$confirm(this.$t("app.refuseModification") + "?").then(() => {
        refuse({
          StudentCode: row.studentNumber,
        }).then(() => {
          this.success();
        });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.getList();
    },
    cellStyle(row) {
      let color = "";
      if (row.column.property) {
        if (row.column.property === "room") {
          color = row.row.roomColor;
        } else if (row.column.property === "bed") {
          color = row.row.bedColor;
        } else {
          color = row.row.personColor;
        }
      }
      return {
        background: color,
      };
    },
    debit(row) {
      this.$refs.debitModal.edit(row.studentNumber, "2", row.roomType);
    },
    isDebit(row) {
      return row.debitNo === "" || row.debitNo === null ? false : true;
    },
    batchDebit() {
      let debitStudentGroup = [];
      let defaultRoomType;
      let roomType =
        this.multipleSelection.length > 0
          ? this.multipleSelection[0].roomType
          : 0;
      this.multipleSelection.forEach((element) => {
        if (element.debitNo === "" || element.debitNo === null) {
          debitStudentGroup.push(element.studentNumber);
          if (roomType !== element.roomType) {
            defaultRoomType = 2;
          }
        }
      });
      if (defaultRoomType == undefined) {
        defaultRoomType = roomType;
      }
      this.$refs.debitModal.edit(debitStudentGroup, "2", defaultRoomType);
    },
    debitSuccess() {
      this.getList();
    },
    showBatchDebit() {
      let debitStudentGroup = [];
      this.multipleSelection.forEach((element) => {
        if (element.debitNo === "" || element.debitNo === null) {
          debitStudentGroup.push(element.studentNumber);
        }
      });
      return debitStudentGroup.length > 0;
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
    returnRoomTypeText(value) {
      let target = this.colorList.find((item) => item.code === value);
      return target?.text;
    },
    returnBedStateText(value) {
      let target = this.colorListSecond.find((item) => item.code === value);
      return target?.text;
    },
    returnStudentTypeText(value) {
      let target = this.colorListThird.find((item) => item.code === value);
      return target?.text;
    },
    returnIsContinueLodge(value) {
      if (value === "1") {
        return "是";
      } else if (value === "2") {
        return this.$t("app.applyOldView.noI");
      } else if (value === "3") {
        return this.$t("app.applyOldView.noII");
      } else if (value === "4") {
        return this.$t("app.applyOldView.noIII");
      }
    },
    returnIsChange(text) {
      if (text == "否") {
        return "是";
      } else if (text == "是") {
        return "否";
      }
      return text;
    },
    generateExportCondition() {
      let condition = "";
      if (this.search.roomCode) {
        condition += "Room is like:" + this.search.roomCode;
      }
      if (this.search.studentNumber) {
        if (condition) {
          condition += ", ";
        }
        condition += "Student ID is like:" + this.search.studentNumber;
      }
      if (this.search.name) {
        if (condition) {
          condition += ", ";
        }
        condition += "Student name is like:" + this.search.name;
      }
      if (this.search.contact) {
        if (condition) {
          condition += ", ";
        }
        condition += "Mobile is like:" + this.search.contact;
      }
      if (this.search.isKeep) {
        if (condition) {
          condition += ", ";
        }
        condition += "Is Keep room:" + (this.search.isKeep == 1 ? "是" : "否");
      }
      if (condition) {
        condition += ", ";
      }
      condition += "Export Datetime is:" + new Date();
      return condition;
    },
  },
};
</script>
<style lang="scss" scoped>
.pre-old-stu {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 200px);
    overflow: auto;
  }
}
</style>
